/*
  Vidéos UGC Quanailles : façade de lecture <qn-ugc-video>
  ------------------------------------------------------------------
  - Au clic sur l'affiche, la balise <video> est créée depuis son <template> puis lancée :
    aucun fichier vidéo n'est demandé avant (snippets/qn-ugc-video-card.liquid).
  - Une seule vidéo à la fois : au démarrage d'une vidéo, les autres cartes UGC de la page se mettent en pause.
  - Jamais d'autoplay, jamais de son sans clic ; aucun écouteur global, aucune dépendance.
*/
if (!customElements.get('qn-ugc-video')) {
  customElements.define(
    'qn-ugc-video',
    class QnUgcVideo extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button.qn-ugc__play');
        if (!this.button) return;
        this.onClick = this.load.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      load() {
        const template = this.querySelector('template');
        if (!template || this.querySelector('video')) return;

        const video = template.content.firstElementChild.cloneNode(true);
        video.addEventListener('play', () => QnUgcVideo.pauseOthers(video));
        this.appendChild(video);
        this.classList.add('is-playing');

        // Lancement dans le geste utilisateur (exigé par Safari iOS) ; en cas de refus, les contrôles natifs restent
        const playing = video.play();
        if (playing && playing.catch) playing.catch(() => {});

        // Le focus passe au lecteur avant de retirer le bouton, pour ne pas le perdre au clavier
        video.focus({ preventScroll: true });
        this.button.hidden = true;
      }

      static pauseOthers(current) {
        document.querySelectorAll('qn-ugc-video video').forEach((video) => {
          if (video !== current && !video.paused) video.pause();
        });
      }
    }
  );
}
